import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put, select } from 'redux-saga/effects';
import { reducePolicyTestOverride } from '../../actions/policy/reducePolicyTestOverride';
import { selectEntity } from '../../selectors/policy/selectEntity';

export function* getPolicyTestOverrideSaga() {
    try {
        yield put(reduceLoading({ code: 'getPolicyTestOverride', value: true }));
        const session = yield getSessionSaga();
        const entity = yield select(selectEntity());

        const response = yield call(fetch, `/api/policyTestOverride/${entity}`, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
        });

        const result = yield call([response, 'json']);
        yield put(reduceOperation(result.operation));

        if (!result.operation.status) {
            yield put(reduceLoading({ code: 'getPolicyTestOverride', value: false }));
            return;
        }

        yield put(reducePolicyTestOverride(result.data));
        yield put(reduceLoading({ code: 'getPolicyTestOverride', value: false }));
    } catch (error) {
        console.log('Error while calling Get PolicyTestOverride API - ', error);
        yield put(reduceLoading({ code: 'getPolicyTestOverride', value: false }));
    }
}
